export enum ProductType {
    Generic = 1,
    RouterStandard = 2,
    RouterATA = 3,
    Voice = 4
}